import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { ValidationErrors } from '@angular/forms';
import {
  PledgeRead,
  Parameters,
} from '@app/forms/subscription/definition/interface/Pledge';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'lmnp-amount',
    templateUrl: './lmnp-amount.component.html',
    styleUrls: ['./lmnp-amount.component.scss'],
    standalone: false
})
export class LmnpAmountComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  feilds = {
    investmentAmount: 'lmnpInvestmentAmount',
    taxReductionAmount: 'lmnpTaxReductionAmount',
  };
  error: ValidationErrors = null;
  sessionConsultant: boolean = false;
  pledge: PledgeRead;
  parameters: Parameters;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.pledge = this.subscriptionFacade.getPledge();
    this.parameters = this.pledge?.parameters;

    this.sessionConsultant =
      !!this.pledge && !!this.subscriptionFacade?.getUser()?.sessionConsultant;
    this.subscriptionFacade.initForm(this, {
      sessionConsultant: this.sessionConsultant,
    });
    this.formValueChanges();
  }
  formValueChanges() {
    this.subscriptionFacade
      .setupFormValueAmountChanges(
        this.form,
        this.feilds,
        this.sessionConsultant,
      )
      .pipe(untilDestroyed(this))
      .subscribe(error => {
        this.error = error;
      });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
